/* eslint-disable no-magic-numbers */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react'
import { SlideDown } from 'react-slidedown'

import { split, removeElementFromArray } from '~/utils/array'
import { getCombinedSort } from '~/utils/filtering'
import { track } from '~/utils/tracking'

import Facet from './facet'
import styles from './styles.module.css'

const ShowMoreButton = ({ hiddenFacetCount, isOpen, setIsOpen }) => (
  <div className={styles.container}>
    <div className={`${styles.facet} ${styles.showMoreFacet}`}>
      <button className={styles.showMoreButton} onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? 'Show less' : `Show ${hiddenFacetCount} more`}
      </button>
    </div>
  </div>
)

const CheckboxFacetsVariant = ({
  data,
  name: facetName,
  tooltipTexts,
  formatLabelFn,
  isLastChild = false,
  sortingFn,
  facetTitle,
  onChangeFilterGroup,
  selectedFiltersByFilterGroup = [],
  maxVisibleFacets = 5
}) => {
  const id = (a) => a
  const [shownFacets, restFacets] = split(getCombinedSort(data, sortingFn), maxVisibleFacets)

  const [isOpen, setIsOpen] = useState(false)

  const handleOnChange = (event, label) => {
    const value = event.target.value
    track(`Filter - ${facetTitle}`, label, value)
    onChangeFilterGroup(
      event.target.checked
        ? [...selectedFiltersByFilterGroup, value]
        : removeElementFromArray(selectedFiltersByFilterGroup, value)
    )
  }

  const FacetMapper = ({ facetArray = [] }) => {
    return facetArray.map(({ value, name, unit, count }) => {
      const label = (formatLabelFn || id)(name || value)
      const checked = selectedFiltersByFilterGroup.some((el) => el === value)
      const tooltipText = (tooltipTexts || {})[value]
      const disabled = count === 0

      return (
        <Facet
          key={`${facetName}${value}${count}`}
          inputName={facetName}
          inputValue={value}
          inputId={`checkbox--${value}`}
          inputDisabled={disabled}
          inputChecked={checked}
          inputOnChange={(event) => handleOnChange(event, label, value)}
          labelName={label}
          labelUnit={unit}
          labelCount={count}
          tooltipText={tooltipText}
          isLastChild={isLastChild}
        />
      )
    })
  }

  return (
    <>
      <FacetMapper facetArray={shownFacets} />

      <If condition={restFacets.length}>
        <SlideDown transitionOnAppear={false}>
          <If condition={isOpen}>
            <FacetMapper facetArray={restFacets} />
          </If>
        </SlideDown>

        <ShowMoreButton
          hiddenFacetCount={restFacets.length}
          visibleFacetCount={shownFacets.length}
          dataLength={data.length}
          maxVisibleFacets={maxVisibleFacets}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
        />
      </If>
    </>
  )
}

export default CheckboxFacetsVariant
